export default __webpack_public_path__ + "static/5bae9e934cf848cb90e78a38cbf5f959-0298ce4503c32dff2190402f02e7e126.jpeg";